<template>
	<div class="sheet-title" :class="{noNewLine: noNewLine}">
		<p class="txt-title-2">{{ title }}</p>
		<div class="action-container ml-auto">
			<AppSwitch class="switch" v-if="withSwitch" :checked="active" ref="switch" @switched="handleSwitchChange" />
			<slot name="extra-buttons"></slot>
			<AppButton v-if="buttonText && !aiButton" :disabled="buttonDisabled" :outline="buttonOutline" :loading="buttonLoading" @click="$emit('click-button')" :text="buttonText" />
			<AiButton v-if="buttonText && !!aiButton" :disabled="buttonDisabled" :loading="buttonLoading" @click="$emit('click-button')" :text="buttonText" />
		</div>
	</div>
</template>

<script>
import AppButton from "@/shared/components/AppButton.vue";
import AiButton from "@/console-new/components/shared/AiButton.vue";
import AppSwitch from "@/shared/components/AppSwitch.vue";

export default {
	name: "ModalHeader",
	components: {AppButton, AiButton, AppSwitch},
	emits: ["click-button", "switched"],
	props: {
		title: {type: String, default: ""},
		buttonText: {type: String, default: null},
		withSwitch: {type: Boolean, default: false},
		active: {type: Boolean, default: false},
		buttonDisabled: {type: Boolean, default: false},
		buttonLoading: {type: Boolean, default: false},
		buttonOutline: {type: Boolean, default: false},
		aiButton: {type: Boolean, default: false},
		noNewLine: {type: Boolean, default: false},
	},
	methods: {
		handleSwitchChange(value) {
			this.$emit("switched", value);
		},
	}
}
</script>

<style scoped lang="scss">
.sheet-title {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 10px;
	background-color: var(--color-bg-primary-2);
	border-radius: 13px;
	padding: 10px;
	box-shadow: $box_shadow_inset;
	flex-wrap: wrap;
	gap: 8px;
	
	@media (max-width: 400px) {
		justify-content: flex-end;
	}

	&.noNewLine {
		flex-wrap: nowrap;
		justify-content: space-between;

		.txt-title-2 {

			@media (max-width: 400px) {
				width: auto;
				margin-bottom: 0;
			}
		}
	}
}
.switch {
	margin-left: auto;
	margin-right: 10px;
}
.txt-title-2 {
	@include noSelect;
	@include truncateString(2);
	padding-right: 5px;
	@media (max-width: 768px) {
		font-size: 16px;
	}
	@media (max-width: 400px) {
		width: 100%;
	}
}
.ml-auto {
	margin-left: auto;
}
.action-container {
	display: flex;
	align-items: center;
	gap: 8px;

}
</style>